"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationCenter = exports.notificationBox = exports.Notification = void 0;
const mithril_1 = __importDefault(require("mithril"));
const helpers_1 = require("../utils/helpers");
const TIME = 10000;
exports.Notification = {
    notifications: {},
    uid: 1,
    warn(...content) {
        this.add(content, 'warning');
    },
    error(...content) {
        this.add(content, 'danger');
    },
    info(...content) {
        this.add(content, 'info');
    },
    bold(...content) {
        this.add(content, 'dark');
    },
    success(...content) {
        this.add(content, 'success');
    },
    add(content, style) {
        let uid = (this.uid += 1);
        let box = {
            createdAt: (new Date() * 1),
            view: (0, exports.notificationBox)(content, style, `n${uid}`, () => { this.remove(uid); })
        };
        window.setTimeout(() => {
            delete this.notifications[`n${uid}`];
            mithril_1.default.redraw();
        }, TIME);
        this.notifications[`n${uid}`] = box;
        mithril_1.default.redraw();
    },
    remove(uid) {
        delete this.notifications[`n${uid}`];
        mithril_1.default.redraw();
    },
    view(_node) {
        let o = [];
        for (let uid in this.notifications) {
            o.push(this.notifications[uid].view);
        }
        return (0, mithril_1.default)("div", {
            class: "notification-container",
        }, o);
    }
};
let _uid = 0;
const uid = () => { return `${_uid += 1}`; };
const notificationBox = (content, style, key, onClose) => {
    return (0, mithril_1.default)("article", {
        class: `notification message is-${style}`,
        key: key || uid(),
        onbeforeremove(vnode) {
            vnode.dom.classList.add("notification-fade-out");
            return new Promise(function (resolve) {
                setTimeout(resolve, 1000);
            });
        }
    }, (0, helpers_1.ifTrue)(!!onClose, (0, mithril_1.default)("button", {
        class: "delete is-pulled-right",
        style: { "top": "0.5rem", "right": "0.5rem" }, "aria-label": "delete",
        onclick: (evt) => { evt.preventDefault(); onClose(); }
    })), (0, mithril_1.default)("div", { class: "message-body" }, content));
};
exports.notificationBox = notificationBox;
const renderNotificationPopup = () => {
    return (0, mithril_1.default)(".notification-center-popup");
};
const notificationCenter = () => {
    return (0, mithril_1.default)(".notification-center", renderNotificationPopup(), (0, helpers_1.iconSpan)("fa-bell", "is-size-5"), (0, mithril_1.default)("span", "Notifications"));
};
exports.notificationCenter = notificationCenter;
window.N = exports.Notification;
